import { render } from "./AuthLoadingPage.vue?vue&type=template&id=2c7ece60&scoped=true"
import script from "./AuthLoadingPage.vue?vue&type=script&lang=js"
export * from "./AuthLoadingPage.vue?vue&type=script&lang=js"

import "./AuthLoadingPage.vue?vue&type=style&index=0&id=2c7ece60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7ece60"]])

export default __exports__